import React from 'react'
import Link from 'next/link';

function RssFeed() {
  return (
    <div className="flex w-full flex-row justify-items-center align-center justify-evenly pt-4 ">
        <a href="/rss.xml" target="_blank" title="RSS Blog Feed" className="flex align-center border text-xs border-gray-100 p-4 rounded-lg hover:text-white hover:bg-maturity-500"><i className="flaticon-rss mr-2 text-[1rem]"></i> RSS</a>
        <a href="/atom.xml" target="_blank" title="ATOM Blog Feed" className="flex align-center border text-xs border-gray-100 p-4 rounded-lg hover:text-white hover:bg-maturity-500" ><i className="flaticon-rss mr-2 text-[1rem]"></i> ATOM</a>
        <a href="/rss.json" target="_blank" title="JSON Blog Feed" className="flex align-center border text-xs border-gray-100 p-4 rounded-lg hover:text-white hover:bg-maturity-500"><i className="flaticon-rss mr-2 text-[1rem]"></i> JSON</a>
    </div>
  )
}

export default RssFeed;